var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteXIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 1.33398C4.31337 1.33398 1.33337 4.31398 1.33337 8.00065C1.33337 11.6873 4.31337 14.6673 8.00004 14.6673C11.6867 14.6673 14.6667 11.6873 14.6667 8.00065C14.6667 4.31398 11.6867 1.33398 8.00004 1.33398ZM8.00004 13.334C5.06004 13.334 2.66671 10.9407 2.66671 8.00065C2.66671 5.06065 5.06004 2.66732 8.00004 2.66732C10.94 2.66732 13.3334 5.06065 13.3334 8.00065C13.3334 10.9407 10.94 13.334 8.00004 13.334ZM10.3934 4.66732L8.00004 7.06065L5.60671 4.66732L4.66671 5.60732L7.06004 8.00065L4.66671 10.394L5.60671 11.334L8.00004 8.94065L10.3934 11.334L11.3334 10.394L8.94004 8.00065L11.3334 5.60732L10.3934 4.66732Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteXIcon);
export default __webpack_public_path__ + "static/media/white-x-icon.d94da0fa.svg";
export { ForwardRef as ReactComponent };